module.exports = __webpack_public_path__ + "dist/assets/img/coffee.78a2ef47.svg";